import React, { useRef, useMemo, useEffect, useContext, useState, useCallback } from 'react';
import * as s_form from './Forms.module.css'
import './Common.module.css'
//import { CloseIcon, CheckIcon } from './Icons'
import { ThemeContext } from "./Context"

const pad = (n) => String(n).padStart(2, '0');
const dateIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// items is a dictionary with one {label:value} per item
export const PrecompiledForm = ({ dtime, title, items, onDelete, onSubmit, shown }) => {
  const [ inputs, setInputs ] = useState({})
  const [ theme, setTheme ] = useContext(ThemeContext)
  const [ inputColor, setInputColor ] = useState({})
  const [ chosenDate, setChosenDate ] = useState()

  useEffect(()=>{
    if(items) {
      let str = JSON.stringify(items)
      setInputs(JSON.parse(str))
    }
  },[items, shown])

  return (
      <div className={s_form.flexCI}>
        <div
          className={s_form.inputsContainer}
          style={{ backgroundColor: theme.fg, boxShadow: '2px 2px 10px '+theme.stxt,  marginLeft: '5px' }}
        >
          { inputs &&
            Object.keys(inputs).map((label, index) => {
              if(label != "token"){
                return (
                  <div key={index} className={s_form.inputContainer}>
                      <input
                        className={s_form.textInput}
                        style={{
                          backgroundColor: theme.bg,
                          color: inputs[label] ? theme.stxt : theme.stxt+"88",
                          borderColor: theme.lbg
                        }}
                        onFocus={ (i)=>{
                                  i.target.style.backgroundColor = theme.lbg;
                                  i.target.style.color = theme.stxt;
                                }}
                        onBlur={ (i) => {
                            if(i.target.value===''){
                              i.target.style.backgroundColor = theme.ebg;
                              i.target.style.color = theme.ptxt
                            }
                        }}
                        onChange={(elem) => {setInputs({ ...inputs, [label]: elem.target.value })}}
                        placeholder={".."+label+" here.."}
                        value={inputs[label] || ""}
                      ></input>
                  </div>
                )
              }
            })
          }
        </div>
        <div className={s_form.infoContainer}
          style={{ justifyContent: 'space-between',
            height: shown ? "50vh" : "0%",
            width: shown ? "100%" : "0%" }}
        >
          <div style={{flex: 1}}className={s_form.titleContainer}>
            <span color={theme.stxt}>{title}</span>
          </div>
          <hr color={theme.ebg} width={"80%"} height={"2px"} fill={theme.ptxt}/>
          <div className={s_form.flexCI} style={{flexDirection: 'column', flex: 5, fontSize: '2em'}}>
            {
              dtime.date && (
               <div className={s_form.flexCI} style={{flexDirection: 'column', fontWeight: 'bold' }}>
                  <div className={s_form.flexCI} style={{flex: 1}}>
                    {dtime.date.toLocaleDateString('en-NL', {  weekday: 'long' })},
                  </div>
                  <div className={s_form.flexCI} style={{flex: 1}}>
                    {dtime.date.toLocaleDateString('en-NL', {  year: 'numeric', day: 'numeric', month: 'short' })}
                  </div>
               </div>)
            }
            { dtime.slot && <div className={s_form.flexCI} >{dtime.slot}</div>}
          </div>
          <hr color={theme.ebg} width={"80%"} height={"2px"} fill={theme.ptxt}/>
          <div style={{flex: 2}} className={s_form.reviewInfo}>
            <div className={s_form.flexCI}><span style={{ textAlign: 'center' }}>Review and add information about yourself, before confirming the meeting</span></div>
            <div className={s_form.flexCI}><span style={{color: theme.fg}}>(some data is pre-filled)</span></div>
          </div>
          <div style={{flex: 1}}className={s_form.buttonsContainer}>
            <div className={s_form.touchable}>
              <button className={s_form.mainButton} style={{ backgroundColor: theme.fg, boxShadow: "2px 2px 3px "+theme.sfg }}
                  onClick={onDelete}
              >
                  Close
              </button>
            </div>
            <div className={s_form.touchable}>
              <button
                className={s_form.mainButton}
                style={{ backgroundColor: theme.fg, boxShadow: "2px 2px 3px "+theme.sfg }}
                onClick={() => {onSubmit(inputs)}}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}
